/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_DisconnectedInputs */

const vi_station_disconnected = /** @type {(inputs: Station_DisconnectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mất kết nối`)
};

/**

* @param {Station_DisconnectedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_disconnected = /** @type {((inputs?: Station_DisconnectedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_DisconnectedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_disconnected(inputs)
});